module.exports = "/_next/static/images/Ionut_Ciobanu-aba54f3f1fd6d840d2686aad244ee72c.webp";